import React, { useCallback, useEffect, useState } from 'react';
import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { IonButton, IonRow, IonCol } from '@ionic/react';
import moment, { Moment } from 'moment';

import '../UserCommissionReport.scss';

import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import SportAggreagtionReport from './SportAggregationReport';
import CompetitionAggreagtionReport from './ComprtitionAggregationReport';
import EventAggreagtionReport from './EventAggregationReport';
import MarketAggreagtionReport from './MarketAggregationReport';
import SVLS_API from '../../../svls-api';
import { CommissionReportRecord } from '../../../models/CommissionReport';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Breadcrumbs } from '@material-ui/core';
import { ReactComponent as UplineIcon } from "../../../assets/images/icons/commission-report-icon.svg";

const UpLineReport: React.FC = () => {
  const [groupBy, setGroupBy] = useState<
    'SPORT' | 'COMPETITION' | 'EVENT' | 'MARKET'
  >('SPORT');
  const [nRec, setNRec] = useState<number>(40);
  const [page, setPage] = useState<number>(1);
  const [startDate, setStartDate] = useState<Moment>(moment().subtract(6, 'd'));
  const [endDate, setEndDate] = useState<Moment>(moment());
  const [loading, setLoading] = useState<Boolean>(false);
  const [records, setRecords] = useState<CommissionReportRecord[]>([]);
  const [sportId, setSportId] = useState<string>(null);
  const [competitionId, setCompetitionId] = useState<string>(null);
  const [eventId, setEventId] = useState<string>(null);

  {
    /* Breadcrumb variables */
  }
  const [sportName, setSportName] = useState<string>(null);
  const [competitionName, setCompetitionName] = useState<string>(null);
  const [eventName, setEventName] = useState<string>(null);

  const getRequestParams = () => {
    let params = {
      groupBy: 'SPORT',
      nRec: nRec,
      page: page,
      startDate: startDate.startOf('day').toISOString(),
      endDate: endDate.endOf('day').toISOString(),
    };
    if (sportId !== null) {
      params['sportId'] = sportId;
      params['groupBy'] = 'COMPETITION';
    } else {
      return params;
    }
    if (competitionId !== null) {
      params['competitionId'] = competitionId;
      params['groupBy'] = 'EVENT';
    } else {
      return params;
    }
    if (eventId !== null) {
      params['eventId'] = eventId;
      params['groupBy'] = 'MARKET';
    }
    return params;
  };

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const response = await SVLS_API.get('/reports/v2/commission/', {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        params: getRequestParams(),
      });
      if (response.status === 200) {
        setRecords(response.data);
        setLoading(false);
      } else {
        setLoading(false);
        throw new Error(response.data);
      }
    } catch (err) {
      if (err.response && err.response.data) {
        toast.error(err.response.data.message);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, [
    sportId,
    competitionId,
    eventId,
    nRec,
    page,
    startDate,
    endDate,
  ]);

  return (
    <>
      <IonRow>
        <IonCol sizeLg='2' sizeMd='2.2' className='commission-sidebar web-view'>
          <div className="commission-menu">
            <div className="commission-menu-card web-view">
              <div className="commission-menu-card-content">
                <div className="filters-heading">Filters</div>
                <div className="filters-input">
                  <div className="from-date-filter filter-item">
                    <div className="date-label">From</div>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        className="date-filter"
                        InputProps={{
                          disableUnderline: true,
                          readOnly: true,
                        }}
                        disableToolbar
                        variant="inline"
                        format="DD/MM/yyyy"
                        maxDate={endDate}
                        autoOk={true}
                        margin="normal"
                        id="from-date"
                        value={startDate}
                        onChange={(e) => setStartDate(e)}
                      />
                    </MuiPickersUtilsProvider>
                  </div>

                  <div className="to-date-filter filter-item">
                    <div className="filter-label">To</div>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        className="date-filter"
                        InputProps={{
                          disableUnderline: true,
                          readOnly: true,
                        }}
                        disableToolbar
                        variant="inline"
                        format="DD/MM/yyyy"
                        autoOk={true}
                        minDate={startDate}
                        margin="normal"
                        id="to-date"
                        value={endDate}
                        onChange={(e) => setEndDate(e)}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </IonCol>
        <IonCol>
        <div className="reports-ctn commission-report-ctn game-analysis-report-ctn">
          {/* Header section */}
          <div className="header-ctn">
            {/* Page title */}
            <IonRow>
              <div className="page-title" onClick={() => {
                if (groupBy !== 'SPORT') {
                  setGroupBy('SPORT');
                  setEventId(null);
                  setCompetitionId(null);
                  setSportId(null);
                }
              }}><UplineIcon className='title-image' />Upline Report</div>
            </IonRow>
            <div className="upline-report-filters-row admin-pl-filters-row filters-row mob-view">
            <div className="from-date-filter filter-item">
              <div className="filter-label">From</div>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                  className="date-filter"
                  InputProps={{
                    disableUnderline: true,
                    readOnly: true,
                  }}
                  disableToolbar
                  variant="inline"
                  format="DD/MM/yyyy"
                  maxDate={endDate}
                  autoOk={true}
                  margin="normal"
                  id="from-date"
                  value={startDate}
                  onChange={(e) => setStartDate(e)}
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className="to-date-filter filter-item">
              <div className="filter-label">To</div>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                  className="date-filter"
                  InputProps={{
                    disableUnderline: true,
                    readOnly: true,
                  }}
                  disableToolbar
                  variant="inline"
                  format="DD/MM/yyyy"
                  autoOk={true}
                  margin="normal"
                  minDate={startDate}
                  id="to-date"
                  value={endDate}
                  onChange={(e) => setEndDate(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
          </div>

          {/* Breadcrumbs Section */}
          {groupBy !== 'SPORT' ? (
            <Breadcrumbs
              className="commission-report-breadcrumbs"
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <div
                color="inherit"
                onClick={() => {
                  if (groupBy === 'MARKET' || groupBy === 'EVENT') {
                    setGroupBy('COMPETITION');
                    setEventId(null);
                    setCompetitionId(null);
                  }
                }}
                className="breadcrumb-link "
              >
                <div className="breadcrumb-label">{sportName}</div>
              </div>

              {groupBy !== 'COMPETITION' && competitionId !== null ? (
                <div
                  color="inherit"
                  onClick={() => {
                    if (groupBy === 'MARKET') {
                      setGroupBy('EVENT');
                      setEventId(null);
                    }
                  }}
                  className="breadcrumb-link "
                >
                  <div className="breadcrumb-label">{competitionName}</div>
                </div>
              ) : null}

              {groupBy !== 'EVENT' && eventId !== null ? (
                <div className="breadcrumb-label">{eventName}</div>
              ) : null}
            </Breadcrumbs>
          ) : null}

          {/* Reports table */}
          {loading ? null : (
            <div className="content-ctn light-bg">
              {groupBy === 'SPORT' ? 
                records.length > 0 ? (
                <SportAggreagtionReport
                  setSportDetails={(record: CommissionReportRecord) => {
                    setGroupBy('COMPETITION');
                    setSportId(record.sportId);
                    setSportName(record.sportName);
                  }}
                  records={records}
                />
                ): <div className="no-data-row">No records available</div>
              : null}
              {groupBy === 'COMPETITION' ? (
                <CompetitionAggreagtionReport
                  setCompetitionDetails={(record: CommissionReportRecord) => {
                    setGroupBy('EVENT');
                    setCompetitionId(record.competitionId);
                    setCompetitionName(record.competitionName);
                  }}
                  records={records}
                />
              ) : null}
              {groupBy === 'EVENT' ? (
                <EventAggreagtionReport
                  setEventDetails={(record: CommissionReportRecord) => {
                    setGroupBy('MARKET');
                    setEventId(record.eventId);
                    setEventName(record.eventName);
                  }}
                  records={records}
                />
              ) : null}
              {groupBy === 'MARKET' ? (
                <MarketAggreagtionReport records={records} />
              ) : null}
            </div>
          )}

          {/* Pagination Section */}
          <IonRow className="footer-row">
            {page === 1 || loading ? null : (
              <IonButton
                className="bl-btn-prev"
                onClick={() => setPage(page - 1)}
              >
                Prev({page - 1})
              </IonButton>
            )}
            {records.length === nRec && !loading ? (
              <IonButton
                className="bl-btn-next"
                onClick={() => setPage(page + 1)}
              >
                Next({page + 1})
              </IonButton>
            ) : null}
          </IonRow>
        </div>
        </IonCol>
      </IonRow>
    </>
  );
};

export default UpLineReport;
